export default __webpack_public_path__ + "static/Illu personnal assistant-363c29c849e887683363c85e3670ba17.png";